import Circle from '@mui/icons-material/Circle'
import Box from '@mui/material/Box'
import Rating from '@mui/material/Rating'
import Typography from '@mui/material/Typography'
import { getIn, useFormikContext } from 'formik'
import isEmpty from 'lodash/isEmpty'
import { RequiredDot } from 'pages/Survey/components/RequiredDot'
import { LikertScaleQuestion } from 'pages/Survey/types'
import { fontFamilies } from 'theme/styles.utils'
import { useGetObjectTranslation } from 'utils/useGetObjectTranslation'

export const SurveyLikert = ({ question }: { question: LikertScaleQuestion }) => {
  const translatedTitle = useGetObjectTranslation(question.translation, 'title')
  const translatedDescription = useGetObjectTranslation(question.translation, 'description')
  const max = question.maxValue
  const { getFieldProps, setFieldValue, touched: touchedArray, errors } = useFormikContext()
  const { value } = getFieldProps(question.id)
  const { touched, error } = { touched: getIn(touchedArray, question.id), error: getIn(errors, question.id) }
  const errorTextField = !isEmpty(error) && touched
  const helperText = touched && error && error

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" fontFamily={fontFamilies.default}>
        <>
          {translatedTitle}
          {question.isRequired ? <RequiredDot /> : ''}
        </>
      </Typography>
      <Typography variant="body1" color="textSecondary" fontFamily={fontFamilies.default}>
        {translatedDescription}
      </Typography>
      <Box position="relative" width="100%" display="flex" alignItems="center" justifyContent="space-between" mt={2}>
        <Box
          position="absolute"
          top="50%"
          left="calc(1%)"
          right="calc(1%)"
          height={5}
          bgcolor="#ccc"
          zIndex={0}
          sx={{ transform: 'translateY(-50%)' }}
        />
        <Rating
          value={value ? Number(value) : 0}
          max={isNaN(Math.floor(Number(max))) ? 5 : Math.floor(Number(max))}
          precision={1}
          onChange={(_event, value) => {
            setFieldValue(question.id, String(value))
          }}
          icon={<Circle sx={{ zIndex: 1, color: (theme) => theme.palette.primary.dark }} />}
          emptyIcon={<Circle sx={{ zIndex: 1, color: (theme) => theme.palette.common.white }} />}
          sx={{
            width: '100%',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'space-between',
            '& .MuiRating-icon': {
              mx: 'auto',
            },
            '& label:last-child': {
              display: 'none',
            },
          }}
        />
      </Box>
      <Box display="flex" justifyContent="space-between" width="100%">
        {Array.from({
          length: isNaN(Math.floor(Number(max))) ? 5 : Math.floor(Number(max)),
        }).map((_, i) => (
          <Box
            key={i}
            sx={{
              textAlign: 'center',
              width: `${100 / ((isNaN(Math.floor(Number(max))) ? 5 : Math.floor(Number(max))) + 24)}%`,
            }}
          >
            <Typography variant="h4" color="textPrimary" fontWeight="bold" fontFamily={fontFamilies.default}>
              {i + 1}
            </Typography>
          </Box>
        ))}
      </Box>
      {errorTextField && (
        <Typography color="error" mt={1}>
          {helperText}
        </Typography>
      )}
    </Box>
  )
}
